import type { LocalDay } from './model';

const LOCAL_DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function assertLocalDay(value: string): LocalDay {
  if (!LOCAL_DAY_PATTERN.test(value)) throw new Error('Data inválida. Use AAAA-MM-DD.');
  const [year, month, day] = value.split('-').map(Number);
  const candidate = new Date(Date.UTC(year!, month! - 1, day));
  if (candidate.getUTCFullYear() !== year || candidate.getUTCMonth() + 1 !== month || candidate.getUTCDate() !== day) {
    throw new Error('Data inválida.');
  }
  return value;
}

export function todayLocalDay(now = new Date(), timeZone = 'America/Sao_Paulo'): LocalDay {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${value.year}-${value.month}-${value.day}`;
}

export function localDayFromISO(value: string, timeZone = 'America/Sao_Paulo'): LocalDay {
  return todayLocalDay(new Date(value), timeZone);
}

export function addDays(value: LocalDay, amount: number): LocalDay {
  const date = new Date(`${assertLocalDay(value)}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}

export function compareDays(left: LocalDay, right: LocalDay): number {
  return left.localeCompare(right);
}

export function monthBounds(day: LocalDay): { start: LocalDay; end: LocalDay } {
  const [year, month] = day.split('-').map(Number);
  const end = new Date(Date.UTC(year!, month!, 0)).getUTCDate();
  return { start: `${year}-${String(month).padStart(2, '0')}-01`, end: `${year}-${String(month).padStart(2, '0')}-${String(end).padStart(2, '0')}` };
}

export function precedingRange(start: LocalDay, end: LocalDay): { start: LocalDay; end: LocalDay } {
  const length = Math.round((Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86_400_000) + 1;
  return { start: addDays(start, -length), end: addDays(start, -1) };
}

export function formatLocalDay(day: LocalDay): string {
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeZone: 'UTC' }).format(new Date(`${day}T12:00:00Z`));
}

